import { render, staticRenderFns } from "./ModalImportar.vue?vue&type=template&id=464bcf15&"
import script from "./ModalImportar.vue?vue&type=script&lang=ts&"
export * from "./ModalImportar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('464bcf15', component.options)
    } else {
      api.reload('464bcf15', component.options)
    }
    module.hot.accept("./ModalImportar.vue?vue&type=template&id=464bcf15&", function () {
      api.rerender('464bcf15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/TiposProducto/ModalImportar.vue"
export default component.exports